<template>
  <div class="business-area-selector">
    <div class="content">
      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">
        全国
      </el-checkbox>
      <el-checkbox-group v-model="preSelectedOptions" @change="handleCheckboxChange">
        <el-checkbox :key="key" v-for="(item, key) in selectorOptions" :label="item.text">
          {{ item.text }}
        </el-checkbox>
      </el-checkbox-group>
    </div>

    <div class="footer">
      <el-button size="small" @click="handleReset">重 置</el-button>
      <el-button size="small" type="primary" @click="handleSave">保 存</el-button>
    </div>
  </div>
</template>

<script>
import { getAreaJson } from "@/assets/areaJSON";

export default {
  name: "BusinessAreaSelector",
  data() {
    return {
      /** 预选项保存空间，有效期在点击保存按钮前 **/
      preSelectedOptions: [],
      /** 是否全选 **/
      checkAll: false,
    };
  },
  computed: {
    /** 全国 横线 or 勾 **/
    isIndeterminate() {
      return this.preSelectedOptions.length > 0 && this.preSelectedOptions.length < this.selectorOptions.length;
    },
    /** 选择器全部选项 **/
    selectorOptions() {
      return getAreaJson();
    },
    /** 已选择的label arr (只保存text的arr) **/
    businessAreaSelectedText() {
      return this.$store.getters["industryZone/businessAreaSelected"].reduce((prev, cur) => {
        prev.push(cur.text);
        return prev;
      }, []);
    },
    /** 保存前校验，不能为空 **/
    saveInvalid() {
      return this.preSelectedOptions.length === 0;
    },
  },
  watch: {
    /** 监听businessAreaSelectedText，更改选择器的已选状态 **/
    businessAreaSelectedText: {
      handler(val) {
        this.preSelectedOptions = val;
        this.checkAll = this.preSelectedOptions.length === this.selectorOptions.length;
      },
      immediate: true,
    },
  },
  methods: {
    /** 全选或反选 **/
    handleCheckAllChange(checked) {
      const all_labels = this.selectorOptions.reduce((prev, cur) => {
        prev.push(cur.text);
        return prev;
      }, []);
      this.preSelectedOptions = checked ? all_labels : [];
    },
    /** 单个省份勾选反选 **/
    handleCheckboxChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.selectorOptions.length;
    },
    /** 置空 **/
    handleReset() {
      this.preSelectedOptions = [];
      this.checkAll = false;
    },
    /** 保存 **/
    handleSave() {
      if (this.saveInvalid) return this.$message.error("请选择业务地区");

      const businessAreaSelected = this.preSelectedOptions.reduce((prev, cur) => {
        prev.push(this.selectorOptions.find((v) => v.text === cur));
        return prev;
      }, []);
      this.$store.commit("industryZone/updateBusinessAreaSelected", businessAreaSelected);
      this.$store.commit("industryZone/updateIsShowBusinessAreaSelector", false);
    },
  },
};
</script>
<style lang="scss">
@import "../../../../assets/config";

.business-area-selector {
  .el-checkbox {
    height: 36px;
    line-height: 36px;
    padding: 0 12px;
  }

  .el-checkbox__inner {
    border-color: $theme-color;
  }

  .el-checkbox__label {
    font-size: 16px;
    width: 20px;
  }
}
</style>

<style scoped lang="scss">
@import "../../../../assets/config";

.business-area-selector {
  position: absolute;
  top: 0;
  left: 0;

  width: 365px;
  height: 213px;

  background-color: white;
  box-shadow: 0 2px 6px 0 rgb(0 0 0 / 20%);

  display: flex;
  flex-direction: column;

  .content {
    height: 100%;
    overflow-y: auto;
    border-bottom: 1px solid #f3f3f3;
    display: flex;
    flex-direction: column;
  }

  .footer {
    padding: 10px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
